module.exports = __webpack_public_path__ + "assets/img/search.6b3b6428.png";